import React, { useEffect, useState } from "react";

export const ReadingProgressBar = () => {
  const [readingProgress, setReadingProgress] = useState(0);

  useEffect(() => {
    const updateReadingProgress = () => {
      const currentScrollPos = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (scrollHeight) {
        setReadingProgress((currentScrollPos / scrollHeight) * 100);
      }
    };

    window.addEventListener("scroll", updateReadingProgress);

    return () => window.removeEventListener("scroll", updateReadingProgress);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1.5 z-50 bg-gray-200/40 backdrop-blur-sm">
      <div
        className="h-full bg-gradient-to-r from-primary via-primary/95 to-primary transition-all duration-300 ease-out shadow-lg shadow-primary/30"
        style={{ width: `${readingProgress}%` }}
      />
    </div>
  );
};
